import React, { Component } from 'react';
import { connect } from 'react-redux';

import AccountSearchForm from './AccountSearchForm';
import CSRSearchForm from './CSRSearchForm';

export class FormManager extends Component {
  render() {
    const { display, didPickAccount, didPickAgent } = this.props;

    return (
      <>
        {!didPickAccount && display.displaySearch && <AccountSearchForm />}
        {!didPickAgent && display.displayCSR && <CSRSearchForm />}
      </>
    );
  }
}

export function mapStateToProps({ targetAccount: { didPickAccount }, targetAgent: { didPickAgent } }) {
  return { didPickAccount, didPickAgent };
}

export default connect(mapStateToProps)(FormManager);
